import { Injectable } from '@angular/core';
import { TealiumService } from '../tealium.service';

@Injectable({
  providedIn: 'root'
})
export class TealiumSubmitService {

  constructor(
    public tealium: TealiumService
  ) { }

  submitZipcodeModalTealium() {
    const apptFormSubmissionUtagNoVin: any = {};
    apptFormSubmissionUtagNoVin.category_l1 = "VDP";
    apptFormSubmissionUtagNoVin.category_l2 = '(not set)';
    apptFormSubmissionUtagNoVin.category_l3 = '(not set)';
    apptFormSubmissionUtagNoVin.category_l4 = '(not set)';
    apptFormSubmissionUtagNoVin.event = "confirm_zipcode";
    apptFormSubmissionUtagNoVin.event_action = "EngagementType_SRP|||Click";
    apptFormSubmissionUtagNoVin.event_category = "EngagementType";    
    apptFormSubmissionUtagNoVin.event_label = "confirm zipcode";
    apptFormSubmissionUtagNoVin.event_value = "1";  
    apptFormSubmissionUtagNoVin.pagegroup = 'vdp';  

    (window as any).utag_data  = apptFormSubmissionUtagNoVin; 
    this.tealium.link((window as any).utag_data);
  }
}
